import {
  Button,
  Card,
  Col,
  Form,
  Input,
  PageHeader,
  Divider,
  Dropdown,
  Menu,
  message,
  notification,
  Row,
} from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import DovizSelectOption from "../components/toolbox/DovizSelectOption";
import StokKategoriSelectOption from "../components/toolbox/StokKategoriSelectOption";
import StokBirimSelectOption from "../components/toolbox/StokBirimSelectOption";
import useVarsayilanDeger from "../hooks/useVarsayilanDeger";
import strings from "../utils/Localization";
import { PlusOutlined, DownOutlined } from "@ant-design/icons";
import { yuzdeHesala } from "../helpers/HesaplamaHelper";
import { api } from "../helpers/ApiHelper";
import CurrencyInput from "../components/toolbox/CurrencyInput";

function StokEkle() {
  const [showStokBilgileri, setShowStokBilgileri] = useState(false);
  const [digerVergiler, setDigerVergiler] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  const { getDefaultSetting } = useVarsayilanDeger();
  const defaultDovizId = String(getDefaultSetting("doviz"));
  const {
    baslik,
    stokBilgileri,
    stokAlisFiyati,
    stokSatisFiyati,
    urunDetayiAddonAfter,
    digerVergilerAddonAfter,
    kaydet,
  } = strings.stokEkle;

  const onFinish = async (values) => {
    try {
      const {
        urunAdi,
        stokBirimId,
        stokKategoriId,
        barkodNo,
        stokRafi,
        stokKodu,
        gtinNumarasi,
        aciklama,
        vergilerHaricAlisFiyat,
        alisDovizId,
        alisKdvOran,
        alisOtvOran,
        vergilerDahilAlisFiyat,
        vergilerHaricSatisFiyat,
        satisDovizId,
        satisKdvOran,
        satisOtvOran,
        vergilerDahilSatisFiyat,
      } = values;

      //Satış KDV - OTV tutar
      const satisOtvTutar = yuzdeHesala(satisOtvOran, vergilerHaricSatisFiyat);
      const satisOtvliTutar =
        parseFloat(vergilerHaricSatisFiyat) + satisOtvTutar;
      const satisKdvTutar = yuzdeHesala(satisOtvliTutar, satisKdvOran);

      //Alış KDV - OTV tutar
      const alisOtvTutar = yuzdeHesala(alisOtvOran, vergilerHaricAlisFiyat);
      const alisOtvliTutar = parseFloat(vergilerHaricAlisFiyat) + alisOtvTutar;
      const alisKdvTutar = yuzdeHesala(alisOtvliTutar, alisKdvOran);
      setFetchLoading(true);
      const response = await api.post("/stok", {
        StokKategoriId: stokKategoriId,
        StokBirimId: stokBirimId,
        ad: urunAdi,
        aciklama: aciklama,
        Stokvaryantgrup: [
          {
            Barkod: barkodNo,
            Aciklama: aciklama,
            Kod: stokKodu,
            Gtin: gtinNumarasi,
            Raf: stokRafi,
            ResimAd: new Date().valueOf(),
            Stokvaryantgrupfiyat: [
              {
                DovizId: satisDovizId,
                OtvTutar: satisOtvTutar,
                OtvOran: satisOtvOran,
                KdvTutar: satisKdvTutar,
                KdvOran: satisKdvOran,
                Fiyat: vergilerHaricSatisFiyat,
                GenelToplam: vergilerDahilSatisFiyat,
                SatisMi: 1,
              },
              {
                DovizId: alisDovizId,
                OtvTutar: alisOtvTutar,
                OtvOran: alisOtvOran,
                KdvTutar: alisKdvTutar,
                KdvOran: alisKdvOran,
                Fiyat: vergilerHaricAlisFiyat,
                GenelToplam: vergilerDahilAlisFiyat,
                SatisMi: 0,
              },
            ],
          },
        ],
      });

      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
        form.resetFields();
        form.setFields([
          { name: "vergilerHaricAlisFiyat", value: 0 },
          { name: "alisDovizId", value: defaultDovizId },
          { name: "alisKdvOran", value: 0 },
          { name: "alisOtvOran", value: 0 },
          { name: "vergilerDahilAlisFiyat", value: 0 },

          { name: "vergilerHaricSatisFiyat", value: 0 },
          { name: "satisDovizId", value: defaultDovizId },
          { name: "satisKdvOran", value: 0 },
          { name: "satisOtvOran", value: 0 },
          { name: "vergilerDahilSatisFiyat", value: 0 },
        ]);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  const alisFiyatHesaplama = (item) => {
    const {
      vergilerHaricAlisFiyat,
      alisKdvOran,
      alisOtvOran,
      vergilerDahilAlisFiyat,
    } = form.getFieldsValue([
      "vergilerHaricAlisFiyat",
      "alisKdvOran",
      "alisOtvOran",
      "vergilerDahilAlisFiyat",
    ]);
    const otvTutar = yuzdeHesala(alisOtvOran, vergilerHaricAlisFiyat);
    const otvliTutar = parseFloat(vergilerHaricAlisFiyat) + otvTutar;
    const kdvTutar = yuzdeHesala(otvliTutar, alisKdvOran);
    if (item.target.id === "vergilerHaricAlisFiyat") {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilAlisFiyat", value: vergiDahilFiyat },
      ]);
    } else if (item.target.id === "vergilerDahilAlisFiyat") {
      const vergiHaricFiyat = parseFloat(
        vergilerDahilAlisFiyat /
          (alisKdvOran / 100 + 1) /
          (alisOtvOran / 100 + 1)
      ).toFixed(2);
      form.setFields([
        { name: "vergilerHaricAlisFiyat", value: vergiHaricFiyat },
      ]);
    } else {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilAlisFiyat", value: vergiDahilFiyat },
      ]);
    }
  };
  const satisFiyatHesaplama = (item) => {
    const {
      vergilerHaricSatisFiyat,
      satisKdvOran,
      satisOtvOran,
      vergilerDahilSatisFiyat,
    } = form.getFieldsValue([
      "vergilerHaricSatisFiyat",
      "satisKdvOran",
      "satisOtvOran",
      "vergilerDahilSatisFiyat",
    ]);
    const otvTutar = yuzdeHesala(satisOtvOran, vergilerHaricSatisFiyat);
    const otvliTutar = parseFloat(vergilerHaricSatisFiyat) + otvTutar;
    const kdvTutar = yuzdeHesala(otvliTutar, satisKdvOran);
    if (item.target.id === "vergilerHaricSatisFiyat") {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilSatisFiyat", value: vergiDahilFiyat },
      ]);
    } else if (item.target.id === "vergilerDahilSatisFiyat") {
      const vergiHaricFiyat = parseFloat(
        vergilerDahilSatisFiyat /
          (satisKdvOran / 100 + 1) /
          (satisOtvOran / 100 + 1)
      ).toFixed(2);
      form.setFields([
        { name: "vergilerHaricSatisFiyat", value: vergiHaricFiyat },
      ]);
    } else {
      const vergiDahilFiyat = parseFloat(otvliTutar + kdvTutar).toFixed(2);
      form.setFields([
        { name: "vergilerDahilSatisFiyat", value: vergiDahilFiyat },
      ]);
    }
  };

  return (
    <>
      <PageHeader
        ghost={false}
        title={baslik}
        onBack={() => history.goBack()}
        extra={
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            style={{ float: "right" }}
            loading={fetchLoading}
            form="myForm"
          >
            {kaydet}
          </Button>
        }
      />
      <br />
      <Form
        form={form}
        onFinish={onFinish}
        size="middle"
        labelCol={{ span: 8 }}
        labelAlign="left"
        initialValues={{
          satisDovizId: defaultDovizId,
          alisDovizId: defaultDovizId,
        }}
        id="myForm"
      >
        <Row gutter={24}>
          <Col flex={1}>
            <Card>
              <Form.Item
                label={stokBilgileri.urunAdi}
                name="urunAdi"
                rules={[{ required: true }]}
              >
                <Input
                  addonAfter={
                    <Button
                      type="text"
                      size="small"
                      icon={<DownOutlined />}
                      disabled={showStokBilgileri}
                      onClick={() => setShowStokBilgileri(true)}
                    >
                      {urunDetayiAddonAfter}
                    </Button>
                  }
                />
              </Form.Item>
              <StokBirimSelectOption formItemName="stokBirimId" />
              <StokKategoriSelectOption formItemName="stokKategoriId" />
              {showStokBilgileri && <Divider />}
              <Form.Item
                hidden={!showStokBilgileri}
                label={stokBilgileri.barkodNUmarasi}
                name="barkodNo"
              >
                <Input />
              </Form.Item>
              <Form.Item
                hidden={!showStokBilgileri}
                label={stokBilgileri.stokRafi}
                name="stokRafi"
              >
                <Input />
              </Form.Item>
              <Form.Item
                hidden={!showStokBilgileri}
                label={stokBilgileri.stokKodu}
                name="stokKodu"
              >
                <Input />
              </Form.Item>
              <Form.Item
                hidden={!showStokBilgileri}
                label={stokBilgileri.gtinNumarasi}
                name="gtinNumarasi"
              >
                <Input />
              </Form.Item>
              <Form.Item
                hidden={!showStokBilgileri}
                label={stokBilgileri.aciklama}
                name="aciklama"
              >
                <Input.TextArea rows={1} />
              </Form.Item>
            </Card>
          </Col>
          <Col flex={1}>
            <Card>
              <CurrencyInput
                formItemName="vergilerHaricAlisFiyat"
                formItemLabel={stokAlisFiyati.vergilerHaricAlisFiyati}
                required
                addonAfter={
                  <DovizSelectOption
                    size="middle"
                    formItemName="alisDovizId"
                    required
                    formItemLabel={stokAlisFiyati.alisDovizTuru}
                    showKod
                    titleHidden
                    noStyle
                  />
                }
                onChange={alisFiyatHesaplama}
              />
              <CurrencyInput
                formItemName="alisKdvOran"
                formItemLabel={stokAlisFiyati.alisKdvOran}
                required
                addonAfter={
                  <Dropdown
                    trigger={["click"]}
                    overlay={
                      <Menu>
                        <Menu.Item
                          key="0"
                          disabled={digerVergiler}
                          onClick={() => setDigerVergiler(true)}
                        >
                          {digerVergilerAddonAfter}
                        </Menu.Item>
                      </Menu>
                    }
                  >
                    <Button
                      type="text"
                      size="small"
                      icon={<PlusOutlined />}
                    ></Button>
                  </Dropdown>
                }
                onChange={alisFiyatHesaplama}
              />
              <CurrencyInput
                hidden={!digerVergiler}
                formItemName="alisOtvOran"
                formItemLabel={stokAlisFiyati.alisOtvOran}
                required
                onChange={alisFiyatHesaplama}
              />
              <CurrencyInput
                formItemName="vergilerDahilAlisFiyat"
                formItemLabel={stokAlisFiyati.vergilerDahilAlisFiyati}
                required
                addonAfter={
                  <DovizSelectOption
                    size="middle"
                    formItemName="alisDovizId"
                    required
                    formItemLabel={stokAlisFiyati.alisDovizTuru}
                    showKod
                    titleHidden
                    noStyle
                  />
                }
                onChange={alisFiyatHesaplama}
              />
              <Divider />
              <CurrencyInput
                formItemName="vergilerHaricSatisFiyat"
                formItemLabel={stokSatisFiyati.vergilerHaricSatisFiyati}
                required
                addonAfter={
                  <DovizSelectOption
                    size="middle"
                    formItemName="satisDovizId"
                    required
                    formItemLabel={stokSatisFiyati.satisDovizTuru}
                    showKod
                    titleHidden
                    noStyle
                  />
                }
                onChange={satisFiyatHesaplama}
              />
              <CurrencyInput
                formItemName="satisKdvOran"
                formItemLabel={stokSatisFiyati.satisKdvOran}
                required
                addonAfter={
                  <Dropdown
                    trigger={["click"]}
                    overlay={
                      <Menu>
                        <Menu.Item
                          key="0"
                          disabled={digerVergiler}
                          onClick={() => setDigerVergiler(true)}
                        >
                          {digerVergilerAddonAfter}
                        </Menu.Item>
                      </Menu>
                    }
                  >
                    <Button
                      type="text"
                      size="small"
                      icon={<PlusOutlined />}
                    ></Button>
                  </Dropdown>
                }
                onChange={satisFiyatHesaplama}
              />
              <CurrencyInput
                hidden={!digerVergiler}
                formItemLabel={stokSatisFiyati.satisOtvOran}
                formItemName="satisOtvOran"
                required
                onChange={satisFiyatHesaplama}
              />
              <CurrencyInput
                formItemLabel={stokSatisFiyati.vergilerDahilSatisFiyati}
                formItemName="vergilerDahilSatisFiyat"
                required
                addonAfter={
                  <DovizSelectOption
                    size="middle"
                    formItemName="satisDovizId"
                    required
                    formItemLabel={stokSatisFiyati.satisDovizTuru}
                    showKod
                    titleHidden
                    noStyle
                  />
                }
                onChange={satisFiyatHesaplama}
              />
            </Card>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default StokEkle;
